import React, { useState, useEffect } from "react";
import doctor from "../assests/grp-doc.png";
import Specializations from "./Spicializations/Specializations";
import BookMedicalService from "./MedicalService/BookMedicalService";
import AccesptedInsurence from "./AccesptedInsurence";
import HospitalAdCarousel from "./AdBanner";
import Testimonials from "./Testimonials";
import "../Login/LoginPage.css";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getSearchAll } from "../Redux/Slice/SearchAllSlice";

import {
  Paper,
  Typography,
  Box,
  TextField,
  IconButton,
  InputAdornment,
} from "@mui/material";

import { FaSearch } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import SEO from "../SEO";
import { useCanonicalUrl } from "../useCanonicalUrl";

const HomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const canonical = useCanonicalUrl();

  const [searchText, setSearchText] = useState("");
  const { items } = useSelector((state) => state.allSearchValue);

  useEffect(() => {
    AOS.init({ duration: 1000, once: false, mirror: true });
  }, []);

  const handleNavigate = (value) => {
    navigate(`/booking-doc-list?search=${encodeURIComponent(value)}`);
  };

  return (
    <>
      <SEO
        title="Trust Doc – Book Doctors and Medical Services Online"
        description="Book trusted doctors, medical specialists and health services online instantly."
        canonical={canonical}
      />

      <div>
        {/* Hero Section */}
        <div className="hero-container">
          <div className="hero-content">
            {/* Left - Heading & Search */}
            <div className="hero-left">
              <div className="hero-heading">
                Connecting You
                <br />
                With Doctors You Can Trust
              </div>

              <Box sx={{ position: "relative", width: "100%", mt: 2 }}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="medium"
                  placeholder="Search hospital, branch, specialty or doctor"
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    if (e.target.value.trim()) {
                      dispatch(getSearchAll({ keyword: e.target.value }));
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() =>
                            searchText &&
                            dispatch(getSearchAll({ keyword: searchText }))
                          }
                        >
                          <FaSearch />
                        </IconButton>
                      </InputAdornment>
                    ),
                    sx: { backgroundColor: "#fff", borderRadius: "8px" },
                  }}
                />

                {searchText && items?.data && (
                  <Paper
                    elevation={4}
                    sx={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      width: "100%",
                      zIndex: 1300,
                      mt: 1,
                      maxHeight: 400,
                      overflowY: "auto",
                      p: 2,
                      borderRadius: 2,
                    }}
                  >
                    {/* 🏥 Hospitals */}
                    {items.data.hospitals?.length > 0 && (
                      <>
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: 700, mb: 1 }}
                        >
                          Hospitals
                        </Typography>
                        {items.data.hospitals.map((h) => (
                          <Box
                            key={h.hospitalId}
                            sx={{
                              p: 1,
                              "&:hover": {
                                backgroundColor: "#f5f5f5",
                                cursor: "pointer",
                              },
                              borderRadius: 1,
                            }}
                            onClick={() => handleNavigate(h.hospitalName)}
                          >
                            <Typography sx={{ fontWeight: 600 }}>
                              {h.hospitalName}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {h.address}, {h.city}
                            </Typography>
                          </Box>
                        ))}
                      </>
                    )}

                    {/* 🏢 Branches */}
                    {items.data.branches?.length > 0 && (
                      <>
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: 700, mt: 2, mb: 1 }}
                        >
                          Branches
                        </Typography>
                        {items.data.branches.map((b) => (
                          <Box
                            key={b.branchId}
                            sx={{
                              p: 1,
                              "&:hover": {
                                backgroundColor: "#f5f5f5",
                                cursor: "pointer",
                              },
                              borderRadius: 1,
                            }}
                            onClick={() => handleNavigate(b.branchName)}
                          >
                            <Typography sx={{ fontWeight: 600 }}>
                              {b.branchName}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {b.hospitalName}
                            </Typography>
                          </Box>
                        ))}
                      </>
                    )}

                    {/* 🩺 Specialities */}
                    {items.data.specialities?.length > 0 && (
                      <>
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: 700, mt: 2, mb: 1 }}
                        >
                          Specialities
                        </Typography>
                        {items.data.specialities.map((s) => (
                          <Box
                            key={s.specialityId}
                            sx={{
                              p: 1,
                              "&:hover": {
                                backgroundColor: "#f5f5f5",
                                cursor: "pointer",
                              },
                              borderRadius: 1,
                            }}
                            onClick={() => handleNavigate(s.specialityName)}
                          >
                            <Typography sx={{ fontWeight: 600 }}>
                              {s.specialityName}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              {s.branchName || s.hospitalName}
                            </Typography>
                          </Box>
                        ))}
                      </>
                    )}

                    {/* 👩‍⚕️ Doctors */}
                    {items.data.doctors?.length > 0 && (
                      <>
                        <Typography
                          variant="h6"
                          sx={{ fontWeight: 700, mt: 2, mb: 1 }}
                        >
                          Doctors
                        </Typography>
                        {items.data.doctors.map((d) => (
                          <Box
                            key={d.doctorId}
                            sx={{
                              p: 1,
                              display: "flex",
                              alignItems: "center",
                              gap: 1.5,
                              "&:hover": {
                                backgroundColor: "#f5f5f5",
                                cursor: "pointer",
                              },
                              borderRadius: 1,
                            }}
                            onClick={() => handleNavigate(d.doctorName)}
                          >
                            <img
                              src={d.doctorImage}
                              alt={d.doctorName}
                              style={{
                                width: 40,
                                height: 40,
                                borderRadius: "50%",
                                objectFit: "cover",
                              }}
                            />
                            <Box>
                              <Typography sx={{ fontWeight: 600 }}>
                                {d.doctorName}
                              </Typography>
                              <Typography
                                variant="body2"
                                color="text.secondary"
                              >
                                {d.specialityName} — {d.hospitalName}
                              </Typography>
                            </Box>
                          </Box>
                        ))}
                      </>
                    )}
                  </Paper>
                )}
              </Box>
            </div>

            {/* Right side - Doctor Image */}
            <img src={doctor} alt="Doctor" className="hero-img" />
          </div>
        </div>

        <div>
          <Specializations />
        </div>
        <div style={{ marginTop: 10 }}>
          <HospitalAdCarousel />
        </div>

        <div style={{ marginTop: 40 }}>
          <BookMedicalService />
        </div>

        <div>
          <AccesptedInsurence />
        </div>

        <Testimonials />

        {/* Floating Book Now Button */}
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            right: "20px",
            zIndex: 999,
          }}
        >
          <button
            style={{
              background: "linear-gradient(135deg, #1114cbff, #2575fc)",
              color: "white",
              padding: "12px 25px",
              borderRadius: "50px",
              border: "none",
              boxShadow: "0 8px 15px rgba(0,0,0,0.2)",
              cursor: "pointer",
              fontWeight: "600",
              fontSize: "16px",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-3px)";
              e.target.style.boxShadow = "0 12px 20px rgba(0,0,0,0.3)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 8px 15px rgba(0,0,0,0.2)";
            }}
            onClick={() => navigate("/booking-doc-list")}
          >
            Book Now
          </button>
        </div>
      </div>
    </>
  );
};

export default HomePage;
